import React, { useEffect, useState } from 'react';
import api from '../../http';
import FullPageLoader from '../../Components/FullPageLoader/FullPageLoader';
import { DataGrid } from '../../Common/CusomReactGrid/CustomDataGrid';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import { saveAs } from 'file-saver';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import FormatMomentDate from 'Utils/FormatMomentDate';
import { Tooltip } from "react-tooltip";

const emptyEdiResponse = {
    additionalInfo: "",
    categoryCode: "",
    entryDate: "",
    patientAccount: "",
    payerControl: "",
    responseDate: "",
    responseFrom: "",
    status: "",
    statusCode: "",
    statusDate: "",
    transaction277CAPath: "",
    visitID: null,
};

const InsuranceErrorPopup = ({ onClose, row, disableDraggable }) => {
    const uniqueId = "InsuranceErrorPopup"
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(emptyEdiResponse);
    const [screenLoading, setScreenLoading] = useState(false);

    const handleDownload = async (row) => {
        try {
            setScreenLoading(true);
            const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/EDI/Download277CAFile`, { DirectoryPath: row.transaction277CAPath });
            const blob = new Blob([response.data], { type: "text/plain;charset=utf-8" });
            saveAs(blob, row.transaction277CAPath);
            setScreenLoading(false);
        } catch (error) {
            ErrorHandlingMessage(error);
            setScreenLoading(false);
        }
    };

    const columns = [
        {
            name: "Entry Date",
            width: 120,
            key: "entryDate",
            formatter: ({ row }) => FormatMomentDate(row.entryDate),
        },
        {
            name: "Status Date",
            width: 120,
            key: "statusDate",
            formatter: ({ row }) => FormatMomentDate(row.statusDate),
        },
        { name: "Status", width: 120, key: "status" },
        { name: "Patient Account", width: 120, key: "patientAccount" },
        {
            name: "Response",
            width: 280,
            key: "additionalInfo",
            formatter: ({ row }) => (
             <div data-tooltip-id="additionalInfo_tooltip" data-tooltip-content={row.additionalInfo} className='truncate'>
                    {row.additionalInfo}
                </div>
            ),
        },
        { name: "Response From", width: 120, key: "responseFrom" },
        { name: "Category Code", width: 120, key: "categoryCode" },
        { name: "Status Code", width: 120, key: "statusCode" },
        { name: "Payer Control Number", width: 120, key: "payerControl" },
        {
            name: "Action",
            width: 130,
            key: "action",
            formatter: ({ row }) => (
                <CustomButtonNew
                    onClick={() => handleDownload(row)}
                    label={'Download 277CA'}
                    prefixIcon={<img src='/img/download.svg' alt='download' />}
                />
            ),
        },
    ];

    useEffect(() => {
        if (row) {
            (async () => {
                try {
                    setLoading(true);
                    const response = await api.get(`${process.env.REACT_APP_TC_PMS}/api/EDI/FindClaimEdiResponse/${row.visitId}`);
                    setState((prev) => ({
                        ...prev,
                        rows: response.data?.dataModel,
                    }));
                    setLoading(false);
                } catch (error) {
                    ErrorHandlingMessage(error);
                    setLoading(false);
                }
            })();
        }
    }, [row]);

    return (
        <ReactPortal wrapperId={uniqueId}>
            {loading && <FullPageLoader allowFullScreen/>}
            <Tooltip id="additionalInfo_tooltip" style={{ maxWidth: 300, zIndex: 12 }} />
            <div
                data-te-modal-init
                className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                id="exampleModalScrollable"
                tabIndex={-1}
                aria-labelledby="exampleModalScrollableLabel"
                aria-modal="true"
                data-te-open="true"
            >
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div
                        data-te-modal-dialog-ref
                        className="relative w-[1140px] min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                    >
                        {/* Header */}
                        <div
                            id={uniqueId}
                            className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                        >
                            Insurance Errors
                            <button onClick={onClose} className="p-1.5 shrink-0 rounded border border-slate-200 hover:border-slate-300 shadow-sm ml-2">
                                <img src="/img/crossblack.svg" alt="cross" />
                            </button>
                        </div>

                        <div className="px-5 pt-5 overflow-y-auto max-h-[70vh]">
                                <div className="flex min-h-[500px]">
                                    {state.rows &&
                                        <DataGrid
                                            columns={columns}
                                            rows={state.rows}
                                            // height="85%"
                                        />
                                    }
                                </div>
                        </div>

                        {/* Footer */}
                        <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                            <CustomButtonNew variant={"outline"} label={"Cancel"} onClick={onClose} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    );
}

export default InsuranceErrorPopup;
